module.exports = __webpack_public_path__ + "img/30.1c96ab68.jpg";